import { render, staticRenderFns } from "./updateAttributeValue.vue?vue&type=template&id=7b366c81&scoped=true"
import script from "./updateAttributeValue.vue?vue&type=script&lang=js"
export * from "./updateAttributeValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b366c81",
  null
  
)

export default component.exports